import surveyReducer from "./surveyReducer";

export default surveyReducer;
